define.alias("shared/components/shared/post/secondary/high-performer/wrapper", "media/components/shared/post/secondary/high-performer/wrapper");